import React, {Component} from 'react';
import "./NewsDetailsMp.scss"
import Footer from "../../components/FooterMp/FooterMp";
import Navs from "../../components/NavsMp/NavsMp";
import {NavLink} from "react-router-dom";
import newsBanner from "../../static/img/news-page-mp.jpg"
import Scrollbars from "react-custom-scrollbars";

class NewsDetailsMp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            details: {},
            picUrl: ""
        }
    }

    componentDidMount() {
        this.getNewsDetails();
    }

    getNewsDetails() {
        this.$axios.apiList.getNewsDetails({id: this.props.match.params.id})
            .then(res => {
                this.setState({
                    details: res.data,
                    picUrl: res.data.picUrl
                })
            })
            .catch(error => {

            })
    }

    render() {
        let {details, picUrl} = this.state;
        // 滚动条参数
        let scroll = {
            // 如果最终结果表格内容与表格头部无法对齐。
            // 表格头需要增加空白列，弹性布局
            width: '100%',
            // 最大高度，内容超出该高度会出现滚动条
            height: document.body.clientHeight,//网页可见区域高
        };
        return (
            <div className="detailsMp">
                <div className="navs">
                    <Navs/>
                </div>
                <Scrollbars style={scroll}>
                    <div className="picUrl">
                        <img src={newsBanner} alt=""/>
                    </div>
                    <div className="content">
                        {/*<div className="breadcrumb">*/}
                        {/*</div>*/}
                        <div className="title">
                            {details.title}
                        </div>
                        <div className="time">
                            发布时间：{details.createTime}
                        </div>
                        <div className="text" dangerouslySetInnerHTML={{__html: details.details}}/>
                        {
                            details.prevTitle &&
                            <NavLink to={`/newsDetails/${details.prevId}`} className="upper">
                                上一篇 {details.prevTitle}
                            </NavLink>
                        }
                        {
                            details.nextTitle &&
                            <NavLink to={`/newsDetails/${details.nextId}`} className="lower">
                                下一篇 {details.nextTitle}
                            </NavLink>
                        }
                    </div>
                    <div className="footer">
                        <Footer/>
                    </div>
                </Scrollbars>
            </div>
        );
    }
}

export default NewsDetailsMp;
